module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ICP"
  }, [_c('b', [_vm._v("上海市吴中路686号东航金融中心")]), _vm._v(" "), _c('b', [_vm._v("4008-889-889")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("沪ICP备14006107号-1 ")]), _vm._v(" "), _c('b', [_vm._v("沪公网安备 31011202001150号")]), _vm._v(" "), _c('b', [_vm._v("本站支持IPV6")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa94070c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ICP/ICP.vue
// module id = 917
// module chunks = 2